import { __decorate, __metadata } from "tslib";
import { property, state } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import { FetchWorker } from '../common/fetch-worker.js';
import { ComponentLoaderMixin } from '../component-loader/component-loader.js';
import { mixin } from '@trp-dms-digital-shared/ds-ui-library-common';
export class UrlLoadComponent extends mixin(LitElement, ComponentLoaderMixin) {
    constructor() {
        super();
        this.initialized = false;
        this.workerSent = false;
    }
    setHTMLAndCallback() {
        if (this.urlResponseCallback) {
            this.slotHTML = window[this.urlResponseCallback](this.slotHTML);
        }
        this['innerHTML'] = this.slotHTML || '';
    }
    async initialize() {
        this.initialized = true;
        if (this.workerSent) {
            return;
        }
        /**
         * The callback parameter will be the body of the worker
         */
        const worker = new FetchWorker().createGetFetchWorker();
        worker.send(this.urlLoad).then((workerResponse) => {
            this.slotHTML = workerResponse;
            this.setHTMLAndCallback();
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            worker.cancelAll;
        });
        this.workerSent = true;
    }
    render() {
        return html `<slot></slot>`;
    }
}
__decorate([
    state(),
    __metadata("design:type", Object)
], UrlLoadComponent.prototype, "initialized", void 0);
__decorate([
    property({ attribute: 'data-url-load' }),
    __metadata("design:type", String)
], UrlLoadComponent.prototype, "urlLoad", void 0);
__decorate([
    property({ attribute: 'data-url-response-callback' }),
    __metadata("design:type", String)
], UrlLoadComponent.prototype, "urlResponseCallback", void 0);
if ('customElements' in window) {
    if (customElements.get('ds-url-load-component') === undefined) {
        // eslint-disable-next-line
        // @ts-ignore
        customElements.define('ds-url-load-component', UrlLoadComponent);
    }
}
//# sourceMappingURL=url-load-component.js.map